import patternize from '@formatters/patternize';
import dateize from '@formatters/dateize';

import { CELLPHONE_FORMAT } from '@validators/phone';
import { DATE_FORMAT_CHARS_INTERNATIONAL } from '@validators/date';

import filled from '@/components/Form/javascripts/filled';

import { vehicle as vehicleNormalize } from './normalizers';

function normalizeSimulation(json) {
  json.store_id = json.store_id || json.store?.id || json.payload?.store_id;
  json.credere_seller_id = json.seller_id || json.seller?.id || json.credere_seller_id;
  json.accessory_value = filled(json.accessory_value) ? json.accessory_value : json.items?.find((i) => i.type === 'accessory')?.value;
  json.documentation_value = filled(json.documentation_value) ? json.documentation_value : json.items?.find((i) => i.type === 'documentation')?.value;
}

function normalizeVehicle(json) {
  const vehicleID = json?.credere_vehicle_id || json?.credere_vehicle?.id;

  if (vehicleID) {
    json.credere_vehicle_id = vehicleID;
  }
}

function normalizeVehicleModel(json) {
  if (!json?.vehicle_model) {
    return;
  }

  json.name = vehicleNormalize(json.vehicle_model).value;
  json.credere_vehicle_model_id = json.vehicle_model.credere_id;
}

export function normalizeLead(json) {
  if (/\+/.test(json.phone_number)) {
    json.phone_number = patternize(json.phone_number?.replace('+55', ''), { format: CELLPHONE_FORMAT });
  }

  if (/-/.test(json.birthdate)) {
    json.birthdate = dateize(json.birthdate, { format: DATE_FORMAT_CHARS_INTERNATIONAL });
  }

  if (!json.retrieve_gender) {
    json.retrieve_gender = json.gender?.credere_identifier;
  }

  if (!json.retrieve_occupation) {
    json.retrieve_occupation = json.occupation?.credere_identifier;
  }
}

export default function normalizer(json) {
  normalizeSimulation(json.simulation);

  json.simulation.vehicle = json.simulation.vehicle || {};
  normalizeVehicle(json.simulation.vehicle);
  normalizeVehicleModel(json.simulation.vehicle);

  normalizeLead(json.lead);

  return json;
}
